import { googleLogout } from "@react-oauth/google";
import { Dropdown, message } from "antd";
import React from "react";
import { useCookies } from "react-cookie";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../component/image/logo.png";
import { MenuOutlined, UserOutlined } from "@ant-design/icons";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const location = useLocation();

  const logout = () => {
    googleLogout();
    removeCookie("user");
    message.success("Đăng xuất thành công!");
    navigate("/login");
  };

  const items = [
    {
      key: '1',
      label: <a href={`/profile/${cookies?.user?.id}`}>Profile</a>,
    },
    {
      key: '2',
      label: <a onClick={() => logout()}>Logout</a>,
    },
  ];

  const navLinks = [
    { label: "Topic", to: "/topic" },
    { label: "Blog", to: "/blog" },
    { label: "Playlist", to: "/playlist" },
  ];

  const isActive = (path) => location?.pathname.includes(path);

  return (
    <nav className="sticky top-0 z-40 bg-[#0f1e35] border-b border-white/10">
      <div className="flex items-center justify-between px-4 py-3">
        {/* Left: Menu button (mobile) + Logo */}
        <div className="flex items-center gap-3">
          {/* Hamburger - mobile only */}
          <button
            onClick={onMenuClick}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-gray-300 hover:bg-white/10 transition-colors"
          >
            <MenuOutlined className="text-lg" />
          </button>

          <a href="/" className="flex items-center gap-2">
            <img src={logo} className="w-10 h-10 rounded-full" alt="Logo" />
            <p className="text-white font-bold text-lg hidden sm:block">VuaLingo</p>
          </a>
        </div>

        {/* Center: Nav links (desktop only) */}
        <div className="hidden md:flex items-center gap-0.5">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                isActive(link.to)
                  ? "bg-white/15 text-white"
                  : "text-gray-300 hover:bg-white/10 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Dropdown
            dropdownRender={() => (
              <div className="bg-[#1a2d4a] rounded-xl p-2 shadow-2xl border border-white/10 min-w-[150px]">
                <Link className="block px-3 py-2 rounded-lg text-gray-200 hover:bg-white/10 font-medium text-sm transition-colors" to="/ranking/streak">
                  🔥 BXH Streak
                </Link>
                <Link className="block px-3 py-2 rounded-lg text-gray-200 hover:bg-white/10 font-medium text-sm transition-colors" to="/ranking/timer">
                  ⏱️ BXH Timer
                </Link>
              </div>
            )}
            placement="bottom"
            trigger={['click']}
          >
            <span className={`px-4 py-2 rounded-lg text-sm font-medium cursor-pointer transition-colors ${
              isActive("/ranking")
                ? "bg-white/15 text-white"
                : "text-gray-300 hover:bg-white/10 hover:text-white"
            }`}>
              Ranking
            </span>
          </Dropdown>
        </div>

        {/* Right: User section */}
        <div className="flex items-center gap-3">
          {cookies?.user ? (
            <Dropdown menu={{ items }} placement="bottomRight">
              <div className="cursor-pointer">
                {cookies?.user?.avatar ? (
                  <img src={cookies.user.avatar} className="h-9 w-9 rounded-full object-cover ring-2 ring-white/20" crossOrigin="anonymous" alt="Avatar" />
                ) : (
                  <div className="h-9 w-9 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center shadow">
                    <UserOutlined className="text-white text-sm" />
                  </div>
                )}
              </div>
            </Dropdown>
          ) : (
            <Link
              to="/login"
              className="bg-blue-500 hover:bg-blue-400 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors"
            >
              Đăng nhập
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}
